var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListExpand = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4697 8.78033C17.7626 9.07322 18.2374 9.07322 18.5303 8.78033C18.8232 8.48744 18.8232 8.01256 18.5303 7.71967L12.5303 1.71967C12.2374 1.42678 11.7626 1.42678 11.4697 1.71967L5.46967 7.71967C5.17678 8.01256 5.17678 8.48744 5.46967 8.78033C5.76256 9.07322 6.23744 9.07322 6.53033 8.78033L12 3.31066L17.4697 8.78033ZM6.53033 15.2197C6.23744 14.9268 5.76256 14.9268 5.46967 15.2197C5.17678 15.5126 5.17678 15.9874 5.46967 16.2803L11.4697 22.2803C11.7626 22.5732 12.2374 22.5732 12.5303 22.2803L18.5303 16.2803C18.8232 15.9874 18.8232 15.5126 18.5303 15.2197C18.2374 14.9268 17.7626 14.9268 17.4697 15.2197L12 20.6893L6.53033 15.2197Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgListExpand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-expand.715994c5a9e3d16e29b279b340e2c045.svg";